import './FeatureCard.css';

export default function FeatureCard({ icon, title, desc }) {
  return (
    <div className="fcard">
      <div className="fcard__icon">{icon}</div>
      <h3 className="fcard__title">{title}</h3>
      <p className="fcard__desc">{desc}</p>
    </div>
  );
}
